module.exports = __webpack_public_path__ + "fonts/nunitosans-semibold-webfont.05dfb85.woff";